import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { CTASection } from "@/components/home/CTASection";
import { PlayCircle, X } from "@phosphor-icons/react";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/videos").then((r) => setVideos(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="videos-page">
      <PageHero
        overline="Videos & Case Studies"
        title="Proof you can see"
        subtitle="Factory tours, live inspections and client success stories — full transparency into how we work."
        crumbs={[{ label: "Case Studies" }]}
        image="https://images.pexels.com/photos/15674629/pexels-photo-15674629.jpeg"
      />
      <section className="bg-white py-24 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {videos.map((v, i) => (
              <Reveal key={v.title} delay={(i % 3) * 0.07}>
                <button onClick={() => setActive(v)} data-testid={`video-page-card-${i}`} className="group block w-full overflow-hidden rounded-xl border border-slate-200 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                  <div className="relative h-52 overflow-hidden">
                    <img src={v.thumbnail} alt={v.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                    <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                      <PlayCircle size={56} weight="fill" className="text-white/90 transition-transform group-hover:scale-110" />
                    </div>
                    <span className="absolute bottom-2 right-2 rounded bg-black/70 px-2 py-0.5 text-[11px] font-medium text-white">{v.duration}</span>
                  </div>
                  <div className="p-5">
                    <p className="text-[11px] uppercase tracking-wider font-semibold text-teal">{v.category}</p>
                    <p className="mt-1.5 font-heading text-base font-semibold leading-snug text-ink">{v.title}</p>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-5" onClick={() => setActive(null)}>
          <div className="relative aspect-video w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute -top-10 right-0 text-white"><X size={28} /></button>
            <iframe className="h-full w-full rounded-lg" src={`https://www.youtube.com/embed/${active.youtube_id}`} title={active.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
          </div>
        </div>
      )}
      <CTASection />
    </div>
  );
}
